import toast from "react-hot-toast";

import { truckApi } from "../truck.api";
import { GetTruckBrand, GetTruckBrands } from "./truckBrands.types";

export const truckBrandsApi = truckApi.injectEndpoints({
  endpoints: (build) => ({
    getTruckBrands: build.query<GetTruckBrands["result"], GetTruckBrands["args"]>({
      query: () => "/truck-brand",
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando marcas de caminhão...",
          success: "Marcas de caminhão carregadas com sucesso!",
          error: "Erro ao carregar marcas de caminhão."
        });
      }
    }),
    getTruckBrand: build.query<GetTruckBrand["result"], GetTruckBrand["args"]>({
      query: ({ id }) => `/truck-brand/${id}`,
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando marca de caminhão...",
          success: "Marca de caminhão carregada com sucesso!",
          error: "Erro ao carregar marca de caminhão."
        });
      }
    })
  })
});

truckBrandsApi.enhanceEndpoints({
  addTagTypes: ["TruckBrand"],
  endpoints: {
    getTruckBrands: {
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: "TruckBrand" as const, id })), { type: "TruckBrand", id: "LIST" }] : [{ type: "TruckBrand", id: "LIST" }]
    },
    getTruckBrand: {
      providesTags: (result, error, { id }) => [{ type: "TruckBrand", id }]
    }
  }
});
